import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "context/AuthContext";
import { initializeAnalytics, safePage, trackPageView } from "utils/analytics";

// Operational routes need a title without opting them into analytics.
const operationalTitles = {
  '/min-tur': 'Min tur | Flytte og Fragttilbud',
  '/koersel': 'Kørsel | Flytte og Fragttilbud',
};

export default function AnalyticsObserver() {
  const location = useLocation();
  const { currentUser, loading } = useAuth();
  useEffect(() => {
    if (loading) return;
    if (location.pathname === '/konto-aktivering') return;
    const path = location.pathname + location.search;
    // Let route/auth redirects commit before recording the visible destination.
    const timer = setTimeout(() => {
      if (window.location.pathname !== location.pathname) return;
      const page = safePage(path, document.title);
      if (page) document.title = page.page_title;
      else if (operationalTitles[location.pathname]) {
        document.title = operationalTitles[location.pathname];
      }
      initializeAnalytics(currentUser?.role);
      trackPageView(path, document.title);
    }, 0);
    return () => clearTimeout(timer);
  }, [location.pathname, location.search, currentUser?.role, loading]);
  return null;
}
